import React, { useEffect, useMemo, useState } from 'react';
import { API } from '../helpers';

const BASE = '/remote-api';

const VENDOR_META = {
  openai: { label: 'OpenAI', color: '#10a37f', bg: 'rgba(16,163,127,.12)' },
  anthropic: { label: 'Claude', color: '#d97706', bg: 'rgba(217,119,6,.12)' },
  google: { label: 'Google', color: '#4285f4', bg: 'rgba(66,133,244,.12)' },
  deepseek: { label: 'DeepSeek', color: '#4d6bfe', bg: 'rgba(77,107,254,.12)' },
  xai: { label: 'xAI', color: '#111827', bg: 'rgba(17,24,39,.1)' },
  qwen: { label: '通义千问', color: '#615ced', bg: 'rgba(97,92,237,.12)' },
  zhipu: { label: '智谱 GLM', color: '#2454ff', bg: 'rgba(36,84,255,.12)' },
  moonshot: { label: 'Kimi', color: '#1a6cff', bg: 'rgba(26,108,255,.12)' },
  doubao: { label: '豆包', color: '#00c8a0', bg: 'rgba(0,200,160,.12)' },
  image: { label: '图像', color: '#ec4899', bg: 'rgba(236,72,153,.12)' },
  meta: { label: 'Meta', color: '#0668e1', bg: 'rgba(6,104,225,.12)' },
  mistral: { label: 'Mistral', color: '#ff7000', bg: 'rgba(255,112,0,.12)' },
  default: { label: '其他', color: '#64748b', bg: 'rgba(100,116,139,.12)' },
};

function resolveVendor(name = '', vendorName = '') {
  const n = `${name} ${vendorName}`.toLowerCase();
  if (/midjourney|stable.?diffusion|flux|dall-?e|image|sdxl|nai|novelai/.test(n)) return 'image';
  if (/gemini|gemma|google/.test(n)) return 'google';
  if (/claude|anthropic/.test(n)) return 'anthropic';
  if (/gpt|o1|o3|o4|openai|chatgpt|text-embedding/.test(n)) return 'openai';
  if (/deepseek/.test(n)) return 'deepseek';
  if (/qwen|通义|aliyun|dashscope/.test(n)) return 'qwen';
  if (/grok|xai|x\.ai/.test(n)) return 'xai';
  if (/glm|zhipu|智谱|chatglm/.test(n)) return 'zhipu';
  if (/moonshot|kimi/.test(n)) return 'moonshot';
  if (/doubao|字节|seedream|seed-/.test(n)) return 'doubao';
  if (/llama|meta/.test(n)) return 'meta';
  if (/mistral|mixtral/.test(n)) return 'mistral';
  return 'default';
}

function VendorIcon({ kind, size = 28 }) {
  const meta = VENDOR_META[kind] || VENDOR_META.default;
  const common = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: meta.color,
    xmlns: 'http://www.w3.org/2000/svg',
    'aria-hidden': true,
  };

  switch (kind) {
    case 'openai':
      return (
        <svg {...common}>
          <path d="M22.282 9.821a5.985 5.985 0 0 0-.516-4.91 6.046 6.046 0 0 0-6.51-2.9A6.065 6.065 0 0 0 4.981 4.18a5.985 5.985 0 0 0-3.998 2.9 6.046 6.046 0 0 0 .743 7.097 5.98 5.98 0 0 0 .51 4.911 6.051 6.051 0 0 0 6.515 2.9A5.985 5.985 0 0 0 13.26 24a6.056 6.056 0 0 0 5.772-4.206 5.99 5.99 0 0 0 3.997-2.9 6.056 6.056 0 0 0-.747-7.073zM13.26 22.43a4.476 4.476 0 0 1-2.876-1.04l.141-.081 4.779-2.758a.795.795 0 0 0 .392-.681v-6.737l2.02 1.168a.071.071 0 0 1 .038.052v5.583a4.504 4.504 0 0 1-4.494 4.494zM3.6 18.304a4.47 4.47 0 0 1-.535-3.014l.142.085 4.783 2.759a.771.771 0 0 0 .78 0l5.843-3.369v2.332a.08.08 0 0 1-.033.062L9.74 19.95a4.5 4.5 0 0 1-6.14-1.646zM2.34 7.896a4.485 4.485 0 0 1 2.366-1.973V11.6a.766.766 0 0 0 .388.676l5.815 3.355-2.02 1.168a.076.076 0 0 1-.071 0l-4.83-2.786A4.504 4.504 0 0 1 2.34 7.872zm16.597 3.855l-5.833-3.387L15.119 7.2a.076.076 0 0 1 .071 0l4.83 2.791a4.494 4.494 0 0 1-.676 8.105v-5.678a.79.79 0 0 0-.407-.667zm2.01-3.023l-.141-.085-4.774-2.782a.776.776 0 0 0-.785 0L9.409 9.23V6.897a.066.066 0 0 1 .028-.061l4.83-2.787a4.5 4.5 0 0 1 6.68 4.66zm-12.64 4.135l-2.02-1.164a.08.08 0 0 1-.038-.057V6.075a4.5 4.5 0 0 1 7.375-3.453l-.142.08L8.704 5.46a.795.795 0 0 0-.393.681zm1.097-2.365l2.602-1.5 2.607 1.5v2.999l-2.597 1.5-2.607-1.5z" />
        </svg>
      );
    case 'anthropic':
      return (
        <svg {...common}>
          <path d="M13.827 3.52h3.603L24 20.48h-3.603l-1.674-3.977h-6.94l-1.675 3.977H6.5L13.827 3.52zm.568 11.163h4.27L16.3 8.543l-1.905 6.14zM6.165 3.52h3.82l-6.96 16.96H0L6.165 3.52z" />
        </svg>
      );
    case 'google':
      return (
        <svg {...common} fill="none">
          <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4" />
          <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
          <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
          <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
        </svg>
      );
    case 'deepseek':
      return (
        <svg {...common}>
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3.5c1.93 0 3.5 1.57 3.5 3.5S13.93 12.5 12 12.5 8.5 10.93 8.5 9 10.07 5.5 12 5.5zM12 20c-2.7 0-5.08-1.36-6.5-3.43.03-2.16 4.33-3.34 6.5-3.34s6.47 1.18 6.5 3.34C17.08 18.64 14.7 20 12 20z" />
        </svg>
      );
    case 'xai':
      return (
        <svg {...common}>
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
      );
    case 'qwen':
      return (
        <svg {...common}>
          <path d="M12 2 3.5 6.5v11L12 22l8.5-4.5v-11L12 2zm0 2.3 6.5 3.45v6.9L12 18.1l-6.5-3.45v-6.9L12 4.3zm0 2.7-3.8 6.6h2.2l.6-1.1h2l.6 1.1h2.2L12 7z" />
        </svg>
      );
    case 'zhipu':
      return (
        <svg {...common}>
          <path d="M4 4h16v3.2H9.6V10H18v3.2H9.6V20H4V4z" />
        </svg>
      );
    case 'moonshot':
      return (
        <svg {...common}>
          <path d="M12 2a10 10 0 1 0 10 10A8 8 0 0 1 12 2z" />
        </svg>
      );
    case 'doubao':
      return (
        <svg {...common}>
          <path d="M12 2c-2.8 2.6-4.5 5.8-4.5 9.2 0 4.8 3.4 8.8 4.5 10.8 1.1-2 4.5-6 4.5-10.8C16.5 7.8 14.8 4.6 12 2zm0 6.5a2.7 2.7 0 1 1 0 5.4 2.7 2.7 0 0 1 0-5.4z" />
        </svg>
      );
    case 'image':
      return (
        <svg {...common}>
          <path d="M21 19V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
        </svg>
      );
    case 'meta':
      return (
        <svg {...common}>
          <path d="M12 4.5c-2.4 0-4.4 2.9-5.3 7.1C5.7 8.1 4.5 6 3.2 6 1.7 6 .8 8.3.8 12S1.7 18 3.2 18c1.3 0 2.5-2.1 3.5-5.6.9 4.2 2.9 7.1 5.3 7.1s4.4-2.9 5.3-7.1c1 3.5 2.2 5.6 3.5 5.6 1.5 0 2.4-2.3 2.4-6s-.9-6-2.4-6c-1.3 0-2.5 2.1-3.5 5.6C16.4 7.4 14.4 4.5 12 4.5z" />
        </svg>
      );
    case 'mistral':
      return (
        <svg {...common}>
          <path d="M3 4h4v4H3V4zm7 0h4v4h-4V4zm7 0h4v4h-4V4zM3 11h4v9H3v-9zm14 0h4v9h-4v-9zm-7 5h4v4h-4v-4z" />
        </svg>
      );
    default:
      return (
        <svg {...common}>
          <path d="M12 2a4 4 0 0 1 4 4v1h1a3 3 0 0 1 0 6h-1v1a4 4 0 0 1-8 0v-1H7a3 3 0 0 1 0-6h1V6a4 4 0 0 1 4-4zm-1 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm2 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
        </svg>
      );
  }
}

function formatPrice(m) {
  if (m.quota_type === 1 || m.model_price > 0) {
    const p = Number(m.model_price || 0);
    return { main: `$${p.toFixed(p >= 1 ? 2 : 4)}`, sub: '每次' };
  }
  const ratio = Number(m.model_ratio || 0);
  const est = ratio * 0.002;
  return {
    main: est > 0 ? `$${est.toFixed(4)}` : '按量',
    sub: ratio ? `倍率 ${ratio}` : '每 1K tokens',
  };
}

const FILTERS = [
  { key: 'all', label: '全部', kind: null },
  { key: 'google', label: 'Google', kind: 'google' },
  { key: 'openai', label: 'OpenAI', kind: 'openai' },
  { key: 'anthropic', label: 'Claude', kind: 'anthropic' },
  { key: 'deepseek', label: 'DeepSeek', kind: 'deepseek' },
  { key: 'xai', label: 'xAI', kind: 'xai' },
  { key: 'zhipu', label: 'GLM', kind: 'zhipu' },
  { key: 'image', label: '图像', kind: 'image' },
  { key: 'other', label: '其他', kind: 'default' },
];

const ModelSquare = () => {
  const [models, setModels] = useState([]);
  const [vendors, setVendors] = useState({});
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState('');
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const res = await API.get(`${BASE}/api/pricing`);
        if (cancelled) return;
        const body = res?.data || {};
        const list = Array.isArray(body.data) ? body.data : [];
        const vlist = Array.isArray(body.vendors) ? body.vendors : [];
        const vmap = {};
        vlist.forEach((v) => {
          vmap[v.id] = v.name || v.icon || String(v.id);
        });
        setVendors(vmap);
        setModels(list);
      } catch (e) {
        console.error(e);
        setModels([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const enriched = useMemo(() => {
    return models.map((m) => {
      const name = m.model_name || m.name || '';
      const vendorName = vendors[m.vendor_id] || m.owner_by || '';
      const kind = resolveVendor(name, vendorName);
      return { ...m, name, kind, vendor: vendorName || VENDOR_META[kind]?.label || '' };
    });
  }, [models, vendors]);

  const filtered = useMemo(() => {
    const qq = q.trim().toLowerCase();
    return enriched.filter((m) => {
      if (filter === 'other') {
        if (['google', 'openai', 'anthropic', 'deepseek', 'xai', 'zhipu', 'image'].includes(m.kind)) {
          return false;
        }
      } else if (filter !== 'all' && m.kind !== filter) {
        return false;
      }
      if (!qq) return true;
      return (
        m.name.toLowerCase().includes(qq) ||
        String(m.vendor).toLowerCase().includes(qq) ||
        String(m.enable_groups || '').toLowerCase().includes(qq)
      );
    });
  }, [enriched, q, filter]);

  const grouped = useMemo(() => {
    const order = ['google', 'openai', 'anthropic', 'deepseek', 'xai', 'zhipu', 'qwen', 'moonshot', 'doubao', 'image', 'meta', 'mistral', 'default'];
    const map = {};
    filtered.forEach((m) => {
      if (!map[m.kind]) map[m.kind] = [];
      map[m.kind].push(m);
    });
    return order
      .filter((k) => map[k]?.length)
      .map((k) => ({
        kind: k,
        label: VENDOR_META[k]?.label || k,
        items: map[k].sort((a, b) => a.name.localeCompare(b.name)),
      }));
  }, [filtered]);

  const stats = useMemo(() => {
    const total = enriched.length;
    const vendorsN = new Set(enriched.map((m) => m.kind)).size;
    return { total, vendorsN };
  }, [enriched]);

  return (
    <div className="w-models-page">
      <div className="w-models-hero">
        <div className="w-models-hero-text">
          <h2>模型广场</h2>
          <p>可用模型与参考价格</p>
        </div>
        <div className="w-models-stats">
          <div className="w-models-stat">
            <b>{stats.total}</b>
            <span>模型</span>
          </div>
          <div className="w-models-stat">
            <b>{stats.vendorsN}</b>
            <span>厂商</span>
          </div>
        </div>
      </div>

      <div className="w-models-toolbar">
        <div className="w-models-tools">
          <input
            className="w-search"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="搜索模型 / 厂商…"
          />
        </div>
        <div className="w-model-filters">
          {FILTERS.map((f) => (
            <button
              key={f.key}
              type="button"
              className={`w-model-filter ${filter === f.key ? 'active' : ''}`}
              onClick={() => setFilter(f.key)}
            >
              {f.kind ? (
                <span className="w-model-filter-ico" style={{ background: VENDOR_META[f.kind]?.bg }}>
                  <VendorIcon kind={f.kind} size={14} />
                </span>
              ) : null}
              {f.label}
            </button>
          ))}
        </div>
      </div>

      <div className="w-models-result-bar">
        共 <b>{filtered.length}</b> 个结果
      </div>

      {loading ? (
        <div className="w-loading">加载模型中…</div>
      ) : filtered.length === 0 ? (
        <div className="w-empty">没有匹配的模型</div>
      ) : (
        <div className="w-model-groups">
          {grouped.map((group) => (
            <section key={group.kind} className="w-model-group">
              <div className="w-model-group-head">
                <span
                  className="w-model-group-ico"
                  style={{ background: VENDOR_META[group.kind]?.bg || VENDOR_META.default.bg }}
                >
                  <VendorIcon kind={group.kind} size={16} />
                </span>
                <div>
                  <h3>
                    {group.label}
                    <span> · {group.items.length}</span>
                  </h3>
                </div>
              </div>
              <div className="w-model-grid">
                {group.items.map((m) => {
                  const price = formatPrice(m);
                  const groups = Array.isArray(m.enable_groups) ? m.enable_groups : [];
                  const meta = VENDOR_META[m.kind] || VENDOR_META.default;
                  return (
                    <article key={`${m.name}-${m.vendor_id}`} className="w-model-card">
                      <div className="w-model-card-top">
                        <div className="w-model-icon" style={{ background: meta.bg }}>
                          <VendorIcon kind={m.kind} size={16} />
                        </div>
                        <div className="w-model-info">
                          <div className="w-model-name" title={m.name}>
                            {m.name}
                          </div>
                          <div className="w-model-vendor">{m.vendor || meta.label}</div>
                        </div>
                      </div>
                      <div className="w-model-meta">
                        <span className="w-tag">{m.quota_type === 1 ? '按次' : '按量'}</span>
                        {groups.slice(0, 1).map((g) => (
                          <span key={g} className="w-tag">
                            {g}
                          </span>
                        ))}
                      </div>
                      <div className="w-model-price-row">
                        <div className="w-model-price-main">{price.main}</div>
                        <div className="w-model-price-sub">{price.sub}</div>
                      </div>
                    </article>
                  );
                })}
              </div>
            </section>
          ))}
        </div>
      )}
    </div>
  );
};

export default ModelSquare;
